import {getChartOccupancy, getObjectChartOccupancy, getStackedBarChartBasicConfig} from 'containers/storage/config/charts';
import {COLORS_STORAGE, DEFAULT_VALUE} from 'util/constants';
import {readColors} from 'config/highcharts';

import {invalidateStorageAssigned} from 'modules/store/storageAssigned';
import {invalidateStorageOccupancy} from 'modules/store/storageOccupancy';
import {invalidateStorageDetail} from 'modules/store/storageDetail';
import {invalidateStorageVolume} from 'modules/store/storageVolume';


const CREATE_OCCUPANCY = 'CREATE_OCCUPANCY';
const CREATE_ASSIGNED = 'CREATE_ASSIGNED';
const CREATE_OBJECT_OCCUPANCY = 'CREATE_OBJECT_OCCUPANCY';

// eslint-disable-next-line
export const createNasAssignedChartConfig = (seriesAssigned, seriesUsed, results, average, categories, formatter) => ({
    type: CREATE_ASSIGNED,
    seriesAssigned,
    seriesUsed,
    results,
    average,
    categories,
    formatter
});

export const invalidateStorage = () => dispatch => {
    dispatch(invalidateStorageAssigned());
    dispatch(invalidateStorageOccupancy());
    dispatch(invalidateStorageDetail());
    dispatch(invalidateStorageVolume());
};

/**
 Create the necessary serie to set in the chart
 */
export const createOccupancy = series => ({
    type: CREATE_OCCUPANCY,
    series
});

export const createObjectOccupancy = series => ({
    type: CREATE_OBJECT_OCCUPANCY,
    series
});

/**
 Create the necessary serie to set in the chart
 */
const _createAverageData = (categories, average) => categories.map(category =>
    [category[DEFAULT_VALUE], average]
);


/**
 Create the necessary serie for the average
 */
const _getSumTotalSerie = results => results.reduce((total, currentAssigned) =>
    total + currentAssigned.assignedTb, DEFAULT_VALUE
);
const _getSumTotalOccupied = results => results.reduce((total, currentAssigned) =>
    total + currentAssigned.usedTb, DEFAULT_VALUE
);

const _createAssigned = ({ seriesAssigned, seriesUsed, results, average, categories, formatter }) => {
    const _createSeriesData = () => results.map((result, index) => [categories[index][DEFAULT_VALUE], result.assignedTb]);
    const _createSeriesData2 = () => results.map((result, index) => [categories[index][DEFAULT_VALUE], result.usedTb]);

    const _average = _getSumTotalOccupied(results) / results.length;

    const colors = readColors();

    return {
        ...getStackedBarChartBasicConfig(formatter),
        series: [{
            name:  seriesAssigned,
            data:  _createSeriesData(categories, results),
            color: colors[COLORS_STORAGE.COLORS_STORAGE_ASSIGNED]
        },
        {
            name:  seriesUsed,
            data:  _createSeriesData2(categories, results),
            color: colors[COLORS_STORAGE.COLORS_STORAGE_USED]
        },
        {
            type:  'spline',
            name:  average,
            data:  _createAverageData(categories, _average),
            color: colors[COLORS_STORAGE.COLORS_STORAGE_AVG]
        }]
    };
};

const _createOccupancy = series => getChartOccupancy(series);
const _createObjectOccupancy = series => getObjectChartOccupancy(series);

const _getDefaultState = () => ({
    storageOccupancy: undefined,
    storageObjectOccupancy: undefined,

    storageAssigned:  undefined
});

export const reducer = (state = _getDefaultState(), action = {}) => {
    switch (action.type) {
        case CREATE_OBJECT_OCCUPANCY:
            return {
                ...state,
                storageObjectOccupancy: _createObjectOccupancy(action.series)
            };
    case CREATE_OCCUPANCY:
        return {
            ...state,
            storageOccupancy: _createOccupancy(action.series)
        };
    case CREATE_ASSIGNED:
        return {
            ...state,
            storageAssigned: _createAssigned({
                seriesAssigned: action.seriesAssigned,
                seriesUsed:     action.seriesUsed,
                results:        action.results,
                average:        action.average,
                hired:          action.hired,
                categories:     action.categories,
                formatter:      action.formatter
            })
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/storage.js